"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avatarUtils = void 0;
function hashCode(str) {
  let hash = 0;
  if (str.length == 0) {
    return hash;
  }
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  return hash;
}
const ursaColorKeys = ["aqua", "azure", "blue", "gold", "green", "indigo", "mint", "orange", "orchid", "pink", "red", "rose", "teal", "violet", "yellow"];
const lodestarColorKeys = ["berry", "berryDark10", "berryDark20", "berryLight10", "blue", "blueDark10", "blueDark20", "blueLight10", "green", "greenDark10", "greenDark20", "greenLight10", "orange", "orangeDark10", "orangeDark20", "orangeLight10", "purple", "purpleDark10", "purpleDark20", "purpleLight10", "red", "redDark10", "redDark20", "redLight10", "teal", "tealDark10", "tealDark20", "tealLight10", "yellow", "yellowDark10", "yellowDark20", "yellowLight10"];

/**
 *
 * @param email
 * @returns a key to use with the avatar color prop, that references a themed color from
 * `colorTheme`
 * @deprecated please pass an email to the Avatar component instead, and it will automatically
 * generate a color for you.
 */
function emailToAvatarColor(email) {
  let theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "lodestar";
  if (process.env.NODE_ENV !== "production") {
    if (!email || typeof email !== "string") {
      console.warn("EmailToAvatarColor: Missing email--this function requires a string value to convert to a color.");
    }
  }
  const colorKeys = theme === "lodestar" ? lodestarColorKeys : ursaColorKeys;
  const colorIndex = email ? Math.abs(hashCode(email)) % colorKeys.length : 0;
  const colorKey = colorKeys[colorIndex];
  return colorKey;
}

/**
 * @deprecated please pass an email to the Avatar component instead, and it will automatically
 * generate a color for you.
 */
const avatarUtils = {
  emailToAvatarColor
};
exports.avatarUtils = avatarUtils;
//# sourceMappingURL=avatarUtils.js.map